import * as mutations from './mutations'

let _l = 'CN/'

const qs = new URLSearchParams(location.search)
const locale = qs.get('locale')
const lang = qs.get('lang')


if(locale === 'zh_CN'){
  _l = 'CN/'
}
if(lang === 'cn-ZH'){
  _l = 'CN/'
}
if(locale === 'en_US'){
  _l = 'EN/'
}

if(lang === 'en-US'){
  _l = 'EN/'
}



  const state =  {
    lang: _l === ''? 'EN/':_l,
    needShow: true,
    cur: 0
  }
  export default {
    namespaced:true,
    state,
    mutations
  }
